var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8065 14.7938L7.48282 8.47011L1.15913 14.7938C0.896688 15.0687 0.459279 15.0687 0.196834 14.7938C-0.0656113 14.5313 -0.0656113 14.0939 0.196834 13.819L6.52052 7.49531L0.196834 1.17163C-0.0656113 0.896688 -0.0656113 0.471777 0.196834 0.196834C0.471777 -0.0656113 0.896688 -0.0656113 1.17163 0.196834L7.49531 6.52052L13.819 0.196834C14.0939 -0.0656113 14.5188 -0.0656113 14.7938 0.196834C15.0687 0.459279 15.0687 0.896688 14.7938 1.17163L8.47011 7.49531L14.7938 13.819C15.0562 14.0814 15.0562 14.5188 14.7938 14.7938C14.6688 14.9188 14.4939 14.9938 14.3064 14.9938C14.1189 14.9938 13.9565 14.9188 13.819 14.7938H13.8065Z",
    fill: "#4A525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.037d11f40f9c74c32bb33f8bc94556c6.svg";
export { ForwardRef as ReactComponent };